import React from 'react';
import { Box, Flex, Image, Text } from 'rebass/styled-components';
import Comp from '../../../assets/companies-large/compa.svg';
import Foundry from '../../../assets/companies-large/foundry.svg';
import Solana from '../../../assets/companies-large/solana.svg';
import Invisible from '../../../assets/companies-large/invisible.svg';
import Techstars from '../../../assets/companies-large/techstars.svg';
import FlyFlat from '../../../assets/companies-large/flyFlat.svg';
import GetroHome from '../../../assets/getro-home-network.png';

const AuthSideBar = () => (
  <Flex
    sx={{
      maxWidth: '480px',
      background: 'radial-gradient(243.75% 127.17% at 51.98% 100%, #7E16FF 0%, #4900FF 75.94%, #00005A 100%)',
      height: '100vh',
      pt: '80px',
      flexDirection: 'column',
      justifyContent: 'space-between',
      position: 'fixed',
      right: '0',
      top: '0',
    }}
    color="white"
  >
    <Flex
      sx={{
        px: '40px',
        height: '100%',
        justifyContent: 'space-between',
        flexDirection: 'column',
      }}
    >
      <Flex
        sx={{
          maxWidth: '400px',
          flexDirection: 'column',
          gap: '80px',
        }}
      >
        <Flex sx={{ flexDirection: 'column', gap: '24px' }}>
          <Box
            sx={{
              fontSize: '28px',
              fontWeight: '700',
              lineHeight: '1.2',
              textAlign: 'center',
            }}
          >
            Your next deal or hire starts with a warm intro
          </Box>
          <Text fontSize="18px" fontWeight="500" lineHeight="1.4" textAlign="center">
            Unlock new opportunities for your company or the companies you support by tapping into your extended
            network.
          </Text>
        </Flex>

        <Flex sx={{ flexDirection: 'column', gap: '24px' }}>
          <Text
            fontSize="12px"
            opacity={0.7}
            textAlign="center"
            sx={{
              textTransform: 'uppercase',
              letterSpacing: 1,
            }}
          >
            Trusted by top ecosystems and companies
          </Text>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              svg: {
                fill: 'neutral.0',
              },
            }}
          >
            <Box sx={{ display: 'flex', gap: '24px', justifyContent: 'center' }}>
              <Image src={Comp} sx={{ width: '100px' }} />
              <Image src={Techstars} sx={{ width: '100px' }} />
              <Image src={Invisible} sx={{ width: '100px' }} />
            </Box>
            <Box sx={{ display: 'flex', gap: '24px', justifyContent: 'center' }}>
              <Image src={Foundry} />
              <Image src={Solana} />
              <Image src={FlyFlat} />
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Flex>
    <Image src={GetroHome} />
  </Flex>
);

export default AuthSideBar;
